<template>
  <div>
    <h3 class="title title_mark" style="positon:relative;left:-20px;top:-20px">生长性能</h3>
    <a-table
      :scroll="{ x: 500 }"
      :columns="columns"
      :data-source="list"
      class="nopaddingEstimateTable"
      :pagination="false"
      row-key="id"
      style="margin:-20px 0 0 0"
    >
      <template v-for="el in fixedArr" :slot="el" slot-scope="text,record">
        <span :key="el" v-if="record.name === '饲养周期'">{{ text ? Number(text).toFixed(0) : "-" }}</span>
        <span :key="el" v-else>{{ text ? Number(text).toFixed(2) : "-" }}</span>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  expectationEstimationColumns,
  expectationEstimationList,
} from "../../../../EstimateConfig/estimateConfig";
import { getRequest } from "@/components/Common/Utils/Utils";
import { mapState } from 'vuex'
export default {
  props: ["isAdd", "resId", "tabKey", "details",'energySystemNameA'],
  data() {
    return {
      property: "value",
      mode: 1,
      list: [],
      sectionList: [],
      expectationEstimationList,
      estimateId: getRequest("id"),
      fixedArr: [],
      energySystemName: "",
      energySystem: "",
    };
  },

  computed: {
    ...mapState('estimate',['dataDictionary']),
    columns() {
      let newColumns = this.dealColumns();
      return newColumns;
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    resId(val) {
      if (val) {
        this.getDetails(val);
      }
    },
    tabKey() {
      if (this.resId && this.list.length === 0 && this.energySystem) this.init(this.resId);
   },
    details: {
      handler(data) {
        let { prediction } = data;
        let { energySystem } = prediction;
        this.energySystem = energySystem;
        this.getName();
        this.init(this.resId)
      },
      deep: true,
    },
  },
  methods: {
    dealColumns() {
      let newColumns = [...expectationEstimationColumns];
      let sectionLength = this.sectionList.length;
      this.sectionList.forEach((el, ind) => {
        if (this.mode === 0) {
          if (sectionLength > 1) {
            newColumns.push({
              title: el.name,
              dataIndex: `f${ind + 3}`,
              children: [
                {
                  title: "预估值",
                  dataIndex: `estimation${el.field}`,
                  scopedSlots: { customRender: `estimation${el.field}` },
                  width: 120,
                },
                {
                  title: "观测值",
                  dataIndex: `observation${el.field}`,
                  scopedSlots: { customRender: `observation${el.field}` },
                  width: 120,
                },
              ],
            });
          } else {
            newColumns.push({
              title: "预估值",
              dataIndex: `estimation${el.field}`,
              scopedSlots: { customRender: `estimation${el.field}` },
              width: 120,
            });
            newColumns.push({
              title: "观测值",
              dataIndex: `observation${el.field}`,
              scopedSlots: { customRender: `observation${el.field}` },
              width: 120,
            });
          }
        } else {
          if (sectionLength > 1) {
            newColumns.push({
              title: el.name,
              dataIndex: `f${ind + 3}`,
              children: [
                {
                  title: "预估值",
                  dataIndex: `estimation${el.field}`,
                  scopedSlots: { customRender: `estimation${el.field}` },
                  width: 120,
                },
              ],
            });
          } else {
            newColumns.push({
              title: "预估值",
              dataIndex: `estimation${el.field}`,
              scopedSlots: { customRender: `estimation${el.field}` },
              width: 120,
            });
          }
        }
      });
      return newColumns;
    },

    init() {
      if (this.estimateId && this.isAdd) {
        this.getDetails(this.estimateId);
      } 
      // else if (!this.isAdd && this.resId) {
      //   this.getDetails(this.resId);
      // }
    },
    getName() {
      let obj =
      this.dataDictionary.EnergySystem.find(
        (el) => el.dictKey === this.energySystem
      ) || {};
      if (obj.dictValue){
        this.energySystemName = obj.dictValue.replace("体系", "") || "";
      } 
    },

    getDetails(id) {
      if (!id) return;
      this.sectionList = [];
      this.list = [];
      this.$http
        .get(
          `/sat-maximization/opweightrangeformula/subDetail?predictionId=${id}`
        )
        .then((res) => {
          let { success, data } = res || {};
          if (success) {
            //动态生成头部区间
            let sectionList = []
            data.forEach((el) => {
              sectionList.push({
                name: `${el.initialBwforaa}-${el.finalBwforaa}kg`,
                field: `${el.initialBwforaa}-${el.finalBwforaa}`,
              });
              this.fixedArr.push(`estimation${el.initialBwforaa}-${el.finalBwforaa}`);
              this.fixedArr.push(`observation${el.initialBwforaa}-${el.finalBwforaa}`);
            });
            let list = []
            this.expectationEstimationList.forEach((item) => {
              let obj = {
                name: item.name.indexOf("能量体系名称") >= 0 ? item.name.replace("【能量体系名称】",this.energySystemNameA.replace("体系","")) : item.name,
                unit: item.unit,
              };
              data.forEach((el) => {
                let dataBase = el.opWeightRangeFormula;
                obj[`estimation${el.initialBwforaa}-${el.finalBwforaa}`] = dataBase[item.field1];
                obj[`observation${el.initialBwforaa}-${el.finalBwforaa}`] = dataBase[item.field2];
              });
              list.push(obj);
              
            });
            this.list = [...list]
            this.sectionList = [...sectionList]
          }
        });
    },
  },
};
</script>